import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";

import Loader from "components/Custom/Loader";
import TxtBox from "components/Custom/TxtBox";
import Btn from "components/Custom/Btn";
import ExcelGrid from "components/Custom/ExcelGrid";
import TxtRow from "components/Custom/TxtRow";
import AutoComplete from "components/Custom/AutoComplete";
import UiAccordion from "components/Custom/UiAccordion";
import UiDialog from "components/Custom/UiDialog";

import { LABELS, TITLES, WARNINGS } from "common/lables";
import { DateFunctions } from "common//datefunctions";
import { COMMON_JS } from "common/scripts";

import { DEFAULTS, NOTIFY } from "common/config";
import { COLORS } from "common/colors";

import { TRANS_APIs } from "apihandlers/transaction";
import {ORDER_APIs} from "apihandlers/order"
import AddNewPhysicalVoucher from "./AddNewPhysicalVoucher";

const PhysicalVoucher = (props: any) => {
  const { setDashMenu } = props;

  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState<any>(null);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [manageDialog, setManageDialog] = useState<boolean>(false);
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);
  const [reset, setReset] = useState<boolean>(true);

  const columns = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "5%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "dateTime",
      type: "datetime",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.DATE_TIME,
      width: "15%",
    },
    {
      key: "productName",
      type: "date",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.PRODUCT_NAME,
      width: "10%",
    },
    {
      key: "billdate",
      type: "date",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.ISSUE_RECEIPT,
      width: "10%",
    },
    {
      key: "items",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.OLD_BAG_CARTON,
      width: "10%",
    },
    {
      key: "itemAmt",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.OLD_STRIP_PACKET,
      width: "10%",
    },
    {
      key: "billAmt",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.NEW_BAG_CARTON,
      width: "10%",
    },
    {
      key: "billStatus",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.NEW_STRIP_PACKET,
      width: "10%",
    },
    {
      key: "billReturn",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.DIFF_BAG_CARTON,
      width: "10%",
    },
    {
      key: "billReturn",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.DIFF_STRIP_PACKET,
      width: "10%",
    },
  ];

  useEffect(() => {
    if (loading) {
      getRows();
    }
  }, [loading]);

  const getRows = async () => {
    try {
      const fromDate = (
        document.getElementById("fromDate") as HTMLInputElement
      ).value.trim();
      const toDate = (
        document.getElementById("toDate") as HTMLInputElement
      ).value.trim();
      const args = {
        pageNo: 1,
        pageLength: DEFAULTS.PAGE_LENGTH,
        fromDate,
        toDate,
      };
      setRows(null);
      const res: any = await ORDER_APIs.getOrders(args);
      const { status, response } = res;
      if (status === 200) {
        let list = response.order;
        // for (let i = 0; i < response.order.length; i++) {
        //   list[i]["slNo"] = i + 1;
        // }
        setRows([]);
        setLoading(false);
      }
    } catch (error) {
      console.error("getOrders:", error);
    }
  };

  const onAdd = () => {
    setSelectedRow({});
    setManageDialog(true);
  };
  const reloadGrid = () => {
    setRows(null);
    getRows();
  };

  return (
    <React.Fragment>
      {
        <div className="pageInfo">
          <ul className="breadcrumbs">
            <li onClick={() => setDashMenu(LABELS.HOME)}>{LABELS.HOME}</li>
            <li className="dim">{" / "}</li>
            <li className="active">{TITLES.PHYSICAL_VOUCHER}</li>
          </ul>
          <h4>{TITLES.PHYSICAL_VOUCHER}</h4>
        </div>
      }
      <div className="filterBorder" style={{ width: "96%" }}>
        <UiAccordion id={"filter"} title={LABELS.FILTER}>
          <div className="flexRowAround" style={{ width: "90%" }}>
            <div className="formGroup width30">
              <TxtRow
                label={LABELS.FROM_DATE}
                type={"date"}
                id="fromDate"
                defaultValue={
                  reset
                    ? DateFunctions.getDate("today", "from", "YYYY-MM-DD")
                    : null
                }
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                label={LABELS.TO_DATE}
                type={"date"}
                id="toDate"
                defaultValue={DateFunctions.getDate(
                  "thismonth",
                  "to",
                  "YYYY-MM-DD"
                )}
              />
            </div>
            <div className="formGroup width30">
              <div
                style={{
                  marginTop: "1.5rem",
                  display: "flex",
                  flexDirection: "row",
                  gap: "20px",
                }}
              >
                <Btn
                  size={""}
                  text={LABELS.RESET}
                  bgColor={COLORS.RELOAD_EXPORT}
                  color={COLORS.RELOAD_EXPORT_TEXT}
                  onClick={() => {
                    console.log("Check");
                    setReset(false);
                  }}
                  //loading={isSubmit}
                />
                <Btn
                  text={LABELS.LOAD}
                  onClick={getRows}
                  bgColor={COLORS.GRID_ADD_NEW}

                  // loading={isSubmit}
                />
              </div>
            </div>
          </div>
        </UiAccordion>
      </div>

      <div className="grid excelGridWrapper">
        {rows ? (
          <ExcelGrid
            height={window.innerHeight * 0.55}
            cols={columns}
            rows={rows}
            exportOption={true}
            newRowOption={false}
            exportName={LABELS.PHYSICAL_VOUCHER}
            onReload={reloadGrid}
            onAdd={onAdd}
          />
        ) : (
          <div className="flexRowCenter">
            <Loader />
          </div>
        )}
        {manageDialog && (
          <UiDialog
            title={"Add New" + LABELS.PHYSICAL_VOUCHER + ": "}
            open={true}
            size={"md"}
            onClose={() => {
              setManageDialog(false);
            }}
          >
            <AddNewPhysicalVoucher
              hideHeader={true}
              setManageDialog={setManageDialog}
            />
          </UiDialog>
        )}
      </div>
    </React.Fragment>
  );
};

export default withSnackbar(PhysicalVoucher);
